import type { ReactNode } from 'react';
import { SiteFooter } from './SiteFooter';
import { SiteHeader } from './SiteHeader';

interface SiteLayoutProps {
  /** Show the announcement banners above the navigation. */
  banner: boolean;
  /** The call-to-action block at the top of the footer (see FooterCtas.tsx). */
  footerCta: ReactNode;
  children: ReactNode;
}

export function SiteLayout({ banner, footerCta, children }: SiteLayoutProps) {
  return (
    <>
      <SiteHeader banner={banner} />
      {children}
      <SiteFooter cta={footerCta} />
    </>
  );
}
